// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { Switch, Route } from 'react-router-dom'
import { withRouter } from 'react-router'
import Waypoint from 'react-waypoint'

// Internal Dependencies:
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'
import Advertisement from 'components/Advertisement/Advertisement'
import PageHeader from 'views/page/PageHeader'
import Page from 'views/page/Page'
import Comments from 'components/Comments/Comments'
import Share from 'components/Share/Share'
import PostTileVerImageSmall from 'components/PostTile/PostTileVerImageSmall'

// Redux:
import { closeSearch } from 'actions/search'

class MainLayout extends React.Component {
	componentDidMount() {
		const { dispatch } = this.props

		dispatch( closeSearch() )
	}

	handleWaypointEnter = () => {
		document.body.classList.remove( 'scroll-at-main-inner' )
	}

	handleWaypointLeave = () => {
		document.body.classList.add( 'scroll-at-main-inner' )
	}

	render() {
		const { hasSidebar, location, match, type, currentlyViewedPage } = this.props
		const isAppended = this.props.pageOverride ? true : false
		const page = isAppended ? this.props.pageOverride : this.props.page

		let showPrimaryContent = true,
			showSecondaryContent = true,
			viewsText = '',
			commentsCountText = '',
			relatedMarkup = null,
			authorsMarkup = null,
			authorsCombinedBioMarkup = null,
			authorsNumber,
			authorsClass

		// Related:
		if ( page && page.related ) {
			relatedMarkup = Object.keys( page.related ).map( ( key ) => {
				let item = page.related[ key ]

				return (
					<section key={ key }>
						<PostTileVerImageSmall
							url={ item.url }
							title={ item.title }
							date={ item.date }
							image={ item.featured_image }
							imageAlt={ item.title }
						/>
					</section>
				)
			})
		}

		if ( 'post' == type && page ) {
			authorsNumber = Object.keys( page.authors ).length
			authorsClass = '-authors'

			if ( authorsNumber > 1 ) {
				authorsClass += ' has-multiple'
			}

			authorsMarkup = Object.keys( page.authors ).map( ( key ) => {
				let item = page.authors[ key ]

				return (
					<div className="-author" key={ key }>
						<p>{ item.name }</p>

						{ item.image &&
							<div className="-image">
								<img src={ item.image } alt={ item.name } />
							</div>
						}

						{ ! page.authors.combined_bio &&
							<div className="-bio" dangerouslySetInnerHTML={ { __html: item.bio } } />
						}
					</div>
				)
			} )

			if ( page.authors.combined_bio ) {
				authorsCombinedBioMarkup = <div className="-combined-bio" dangerouslySetInnerHTML={ { __html: page.authors.combined_bio } } />
			}
		}

		return (
			<div className="main-item">
				<PageHeader match={ match } pageOverride={ this.props.pageOverride } />

				<Waypoint
					onEnter={ this.handleWaypointEnter }
					onLeave={ this.handleWaypointLeave }
				/>

				<div className="main-inner">
					{ showPrimaryContent &&
						<div className="primary-wrap">
							<div className="primary-content">
								<ErrorBoundary>
									{ this.props.children }
								</ErrorBoundary>

								{ 'post' == type &&
									<Comments pageOverride={ this.props.pageOverride } />
								}
							</div>
						</div>
					}

					{ showSecondaryContent &&
						<div className="secondary-wrap">
							<div className="secondary-content">
								{ 'post' == type && page &&
									<aside className={ authorsClass }>
										<h3>Written By</h3>

										<div className="-inner">
											{ authorsMarkup }

											{ authorsCombinedBioMarkup }
										</div>
									</aside>
								}

								{ 'post' == type && page &&
									<aside className="-share-wrap">
										<h3>Share</h3>

										<div className="-share">
											<Share type="facebook">
												<i className="icon-facebook-square" aria-hidden="true"></i>
											</Share>

											<Share type="twitter">
												<i className="icon-twitter-square" aria-hidden="true"></i>
											</Share>

											<Share type="google-plus">
												<i className="icon-google-plus" aria-hidden="true"></i>
											</Share>
										</div>
									</aside>
								}

								{ 'post' == type && page &&
									<aside className="-date">
										<p>{ page.date.display }</p>
									</aside>
								}

								{ 'post' == type && page &&
									<aside className="-numbers">
										<div className="-views">
											<i className="icon-eye" aria-hidden="true"></i>

											{ viewsText }
										</div>
									</aside>
								}
							</div>
						</div>
					}
				</div>

				{ relatedMarkup && relatedMarkup.length &&
					<div className="wide-sections">
						<div className="related">
							<div className="-heading">
								<h2>Related</h2>
							</div>

							<div className="-inner">
								<div className="-sections">
									{ relatedMarkup }
								</div>
							</div>
						</div>
					</div>
				}
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		hasSidebar: state.site.hasSidebar,
		page: state.page.selected,
		currentlyViewedPage: state.page.currentlyViewedPage
	}
}

export default withRouter(
	connect( mapStateToProps )( MainLayout )
)
